export default __webpack_public_path__ + "static/7-alternate-attractions-you-must-visit-in-japan-2f900486d7b79e212e4598a856eceb4a.jpg";